import meta from '../data/meta.json';

export type Meta = {
  title: string;
  description: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  ogImage?: string;
  ogLogo?: string;
  twitterCard?: string;
  canonical?: string;
  noindex?: boolean;
  robots?: {
    index?: boolean;
    follow?: boolean;
  };
};

export function getMeta(route: string): Meta {
  const normalized = route.replace(/^\/|\/$/g, "");
  const key = normalized === "" ? "home" : normalized;
  return (meta as Record<string, Meta>)[key] || (meta as Record<string, Meta>)["home"];
}